import React from "react";
import { createTheme } from "@material-ui/core/styles";
import { BrandsEnum } from "../enums";
import * as Helpers from "./common/Helpers";
import { placemnet } from "./common/Theme";
// create default theme to get breakpoints
const theme = createTheme();
const variables = {
    common: {
        borderRadius: 3,
    },
    colors: {
        primary: {
            main: "#35555C",
            dark: "#465A59",
            contrastText: "#FFFFFF",
        },
        secondary: {
            main: "#AB6E44",
            dark: "#875735",
            contrastText: "#FFFFFF",
        },
        error: {
            main: "#C82E2D",
        },
        text: {
            primary: "#333333",
            secondary: "#4c4c4c",
            hint: "#5C7775",
        },
        background: "#FFFFFF",
        elementBackground: "#F6F8F9",
        border: "#DBDBDB",
        infoBackground: "#EEE9E4",
        hover: "#FAFAFA",
        placeholder: "#999999",
        transparent: "#00000000",
        divider: "#EDF1F2",
        teaserBackground: "#BACACD",
        entryBackground: "#DDE4E6",
        icons: {
            main: "#87A2A8",
        },
        gdprText: "#757575",
        tooltipBackgroundColor: "#333333",
    },
};
const colorCard = {
    tableBackground: variables.colors.background,
    inputOutline: variables.colors.border
};
const defaultPathParams = {
    stroke: "currentColor",
    strokeWidth: "1.5",
    fill: "none",
};
function getFontFamily(mainFont) {
    return [
        mainFont ?? "",
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
    ].join(",");
}
const props = Helpers.PrepareProperties(variables);
// More properties here: https://material-ui.com/customization/default-theme/
export const volviano = {
    themeName: "VolviaNo",
    brand: BrandsEnum.VolviaNo,
    compositionBoxWidth: 816,
    containerMaxWidth: 384,
    pageMaxWidth: 1336,
    centred: "0 auto",
    border: "1px solid ",
    borderRadius: variables.common.borderRadius,
    shape: {
        borderRadius: variables.common.borderRadius,
    },
    header: {
        uspBannerBackground: variables.colors.text.primary,
        logoPlacement: placemnet.LEFT,
        dividerColor: variables.colors.elementBackground,
        dividerHeight: 1,
        navigationLinkColor: variables.colors.text.primary,
    },
    breadcrumbs: {
        activeColor: variables.colors.primary.main,
        color: variables.colors.gdprText,
        iconColor: variables.colors.primary.main,
        activeFontFamily: getFontFamily("Volvia"),
        fontWeight: 500
    },
    contentBox: {
        backgroundColor: variables.colors.elementBackground,
        textColor: variables.colors.text.primary,
    },
    webshopEntry: {
        backgroundColor: variables.colors.entryBackground,
        gdprTextColor: variables.colors.gdprText,
    },
    USPContainerBlock: {
        backgroundColor: variables.colors.divider,
        textColor: variables.colors.primary.main,
        headerColor: variables.colors.primary.main,
    },
    mobileAppBlock: {
        backgroundColor: variables.colors.elementBackground,
    },
    footer: {
        backgroundColor: variables.colors.elementBackground,
        border: false,
        mobileFooterPlacement: placemnet.LEFT,
    },
    tooltip: {
        backgroundColor: variables.colors.tooltipBackgroundColor,
    },
    factAndIcon: {
        backgroundColor: variables.colors.elementBackground,
    },
    publishDate: {
        color: variables.colors.gdprText,
    },
    customStyling: {
        global: {
            textArea: {
                legalText: {
                    color: variables.colors.gdprText,
                },
            },
            secondaryButton: {
                color: variables.colors.primary.main,
                border: "1px solid " + variables.colors.primary.main,
                backgroundColor: variables.colors.background,
                "&:hover": {
                    color: "#4D4D4D",
                    border: "1px solid #4D4D4D",
                    backgroundColor: variables.colors.background,
                },
            },
        },
        Header: {
            loginBlock: {
                link: {
                    "&:hover, :active": {
                        background: variables.colors.elementBackground,
                    }
                }
            },
        },
        TextBlock: {
            textBlock: {
                "& .text-area .button-secondary a": {
                    color: variables.colors.primary.main,
                    backgroundColor: variables.colors.background,
                    "&:hover": {
                        color: "red",
                        backgroundColor: variables.colors.background,
                    },
                },
            },
        },
        BreadCrumbs: {
            prevLink: {
                fontWeight: "400!important"
            },
            currentLink: {
                fontWeight: 500
            }
        },
        USPBlock: {
            header: {
                paddingBottom: 0,
                fontWeight: 500,
            },
            headerWrapper: {
                paddingBottom: 11,
            },
            text: {
                fontSize: "1rem",
                lineHeight: "1.5rem",
            }
        },
        ContactUsAreaTabHead: {
            rotatedDropdownIcon: {
                transform: "rotate(45deg)",
            },
        },
    },
    searchBoxContainer: {
        open: {
            borderColor: "#949494",
            borderStyle: "solid",
            borderWidth: "1px",
            borderRadius: "4px",
            backgroundColor: variables.colors.background,
            inputColor: variables.colors.text.primary,
            placeholderColor: "#949494",
        },
        close: {
            placeholderColor: "#4D4D4D",
        },
    },
    searchResultsPage: {
        filterSectionTextColor: variables.colors.text.primary,
        filterSectionBorderColor: variables.colors.entryBackground,
        activeFilterTextColor: variables.colors.text.primary,
        filterSectionBackgroundColor: variables.colors.elementBackground,
        backgroundColor: variables.colors.background,
        subheadTextColor: variables.colors.text.primary,
        resultTitleColor: variables.colors.text.primary,
        resultDescriptionColor: "#323537",
        resultLinkColor: variables.colors.primary.main,
        resultLinkHoverColor: variables.colors.text.primary,
        resultLinkActiveColor: variables.colors.text.hint,
    },
    icons: {
        expandIcon: (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("circle", { cx: "12", cy: "12", r: "10", fill: "#35555C" }),
            React.createElement("path", { d: "M12.5207 12.1568L18.5711 12.1568V11.8432L12.5207 11.8432L12.5207 5.79279L12.2072 5.79281V11.8432L6.15676 11.8432V12.1568L12.2072 12.1568V18.2072L12.5207 18.2072L12.5207 12.1568Z", fill: "white", stroke: "white", strokeWidth: "0.5" }))),
        expandIconRotation: "45",
        helpIcon: (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20.5", height: "20.5", viewBox: "0 0 20.5 20.5" },
            React.createElement("g", { id: "Help", transform: "translate(-1.25 -1.25)" },
                React.createElement("path", { id: "Path_5110", "data-name": "Path 5110", d: "M11.5,21.5a10,10,0,1,1,10-10A10.012,10.012,0,0,1,11.5,21.5Zm0-19.459A9.459,9.459,0,1,0,20.959,11.5,9.5,9.5,0,0,0,11.5,2.041Z", fill: "#35555C", stroke: "#35555C", strokeWidth: "0.5" }),
                React.createElement("path", { id: "Path_5111", "data-name": "Path 5111", d: "M18.065,18.365h-.541v-.541c0-1.459.054-1.784,1.73-3.081,1.568-1.243,2.162-3.027,1.351-4.216a2.8,2.8,0,0,0-2.486-1.189,2.653,2.653,0,0,0-2.324,1.405l-.108.216-.486-.27.108-.216A3.256,3.256,0,0,1,18.065,8.8,3.592,3.592,0,0,1,21.038,10.2c.973,1.459.378,3.514-1.459,4.973-1.514,1.189-1.514,1.351-1.514,2.649Z", transform: "translate(-6.295 -3.351)", fill: "#35555C", stroke: "#35555C", strokeWidth: "0.5" }),
                React.createElement("rect", { id: "Rectangle_2805", "data-name": "Rectangle 2805", width: "0.541", height: "0.865", transform: "translate(11.23 16.635)", fill: "#35555C", stroke: "#35555C", strokeWidth: "0.5" })))),
        searchIcon: (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", { id: "Search" },
                React.createElement("path", { id: "Search_2", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.7597 16.0894C14.4212 17.3414 12.6443 18.0174 10.812 17.9715C8.97976 17.9256 7.23888 17.1616 5.96467 15.8442C4.69046 14.5267 3.98496 12.7613 4.00024 10.9286C4.01553 9.09579 4.75039 7.34241 6.0464 6.0464C7.34241 4.75039 9.09579 4.01553 10.9286 4.00024C12.7613 3.98496 14.5267 4.69046 15.8442 5.96467C17.1616 7.23888 17.9256 8.97976 17.9715 10.812C18.0174 12.6443 17.3414 14.4212 16.0894 15.7597L20 19.672L19.6704 20.0016L15.7597 16.0894ZM17.5078 10.9874C17.5078 12.2772 17.1254 13.538 16.4088 14.6104C15.6923 15.6828 14.6738 16.5187 13.4822 17.0122C12.2906 17.5058 10.9794 17.635 9.7144 17.3833C8.44941 17.1317 7.28744 16.5106 6.37543 15.5986C5.46342 14.6866 4.84234 13.5246 4.59071 12.2597C4.33909 10.9947 4.46823 9.68346 4.96181 8.49187C5.45538 7.30027 6.29122 6.28179 7.36363 5.56523C8.43604 4.84867 9.69685 4.46621 10.9866 4.46621C12.7159 4.46664 14.3742 5.15388 15.5968 6.3768C16.8194 7.59972 17.5062 9.25817 17.5062 10.9874H17.5078Z", fill: "#547B83", stroke: "#547B83", "stroke-width": "0.5" })))),
        contactUsExpandIcon: (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("circle", { cx: "12", cy: "12", r: "10", fill: "#35555C" }),
            React.createElement("path", { d: "M12.5207 12.1568L18.5711 12.1568V11.8432L12.5207 11.8432L12.5207 5.79279L12.2072 5.79281V11.8432L6.15676 11.8432V12.1568L12.2072 12.1568V18.2072L12.5207 18.2072L12.5207 12.1568Z", fill: "white", stroke: "white", strokeWidth: "0.5" }))),
        checkmarkIcon: (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
            React.createElement("g", { id: "Group_12436", "data-name": "Group 12436", transform: "translate(-1060 -323.445)" },
                React.createElement("path", { id: "Path_4742", "data-name": "Path 4742", d: "M12,24A12,12,0,1,0,0,12,12,12,0,0,0,12,24Z", transform: "translate(1084 323.445) rotate(90)", fill: "#dde4e6", fillRule: "evenodd" }),
                React.createElement("path", { id: "Checkmark", d: "M6.425,18.4,13.768,11l.232.23L6.425,18.866,2,14.4l.232-.23Z", transform: "translate(1064 320.513)", fill: "#333", stroke: "#070708", strokeWidth: "0.5", fillRule: "evenodd" })))),
        checkmarkIconCSS: encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g id="Group_12436" data-name="Group 12436" transform="translate(-1060 -323.445)">
      <path id="Path_4742" data-name="Path 4742" d="M12,24A12,12,0,1,0,0,12,12,12,0,0,0,12,24Z" transform="translate(1084 323.445) rotate(90)" fill="#dde4e6" fill-rule="evenodd"/>
      <path id="Checkmark" d="M6.425,18.4,13.768,11l.232.23L6.425,18.866,2,14.4l.232-.23Z" transform="translate(1064 320.513)" fill="#333" stroke="#070708" stroke-width="0.5" fill-rule="evenodd"/>
    </g>
  </svg>`),
        heroCheckmarkIconCSS: encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 13.9778 2.58649 15.9112 3.6853 17.5557C4.78411 19.2002 6.3459 20.4819 8.17316 21.2388C10.0004 21.9957 12.0111 22.1937 13.9509 21.8079C15.8907 21.422 17.6725 20.4696 19.0711 19.0711C20.4696 17.6725 21.422 15.8907 21.8078 13.9509C22.1937 12.0111 21.9957 10.0004 21.2388 8.17317C20.4819 6.3459 19.2002 4.78412 17.5557 3.6853C15.9112 2.58649 13.9778 2 12 2C9.34783 2 6.80429 3.05357 4.92893 4.92893C3.05356 6.8043 2 9.34784 2 12Z" fill="#DDE4E6" stroke="#DDE4E6" stroke-width="0.5"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.038 15.467L18.381 8.06699L18.613 8.29699L11.038 15.933L6.61304 11.467L6.84504 11.237L11.038 15.467Z" fill="#35555C" stroke="#35555C" stroke-width="0.75"/>
      </svg>`),
        closeIcon: (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", { id: "Close" },
                React.createElement("path", { id: "Close_2", d: "M12 12.2955L17.7045 18L18 17.7045L12.2955 12L18 6.2955L17.7045 6L12 11.7045L6.2955 6L6 6.2955L11.7045 12L6 17.7045L6.2955 18L12 12.2955Z", fill: "#547B83", stroke: "#547B83", "stroke-width": "0.5" })))),
        secondaryCloseIcon: (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M12 12.2955L17.7045 18L18 17.7045L12.2955 12L18 6.2955L17.7045 6L12 11.7045L6.2955 6L6 6.2955L11.7045 12L6 17.7045L6.2955 18L12 12.2955Z", fill: "#35555C", stroke: "#35555C", "stroke-width": "0.5" }))),
        excludeIcon: (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M4 20L20 4M4 4L20 20", stroke: variables.colors.entryBackground }))),
        bulletIconCSS: encodeURIComponent(`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="1.6"
        viewBox="0 0 14 1.6"
      >
        <line
          id="Line_861"
          data-name="Line 861"
          x2="14"
          transform="translate(0 0.8)"
          fill="none"
          stroke="#001e50"
          stroke-width="1.6"
        />
      </svg>
    `),
    },
    tabsContainerBlock: {
        backgroundColor: "#D8E5E6",
        buttonTextColor: variables.colors.text.primary,
        buttonBorder: `1px solid ${variables.colors.primary.main}`,
        buttonHoverBorder: `1px solid ${variables.colors.primary.main}`,
        buttonActiveBorder: `2px solid ${variables.colors.primary.main}`,
        buttonActiveTextColor: variables.colors.primary.main,
    },
    popup: {
        backgroundColor: variables.colors.elementBackground,
        headerColor: variables.colors.divider,
    },
    link: {
        showArrow: true,
        showUnderline: false,
    },
    accordionBlock: {
        expandedBackgroundColor: variables.colors.elementBackground,
        comparationTableBackground: variables.colors.elementBackground,
        backgroundColor: variables.colors.divider,
        borderColor: variables.colors.divider,
    },
    tetriaryLink: {
        underlined: false,
    },
    textBlock: {
        infoBackgroundColor: variables.colors.infoBackground,
        infoBorderColor: variables.colors.text.primary,
        borderColor: variables.colors.primary.main,
        tableBackground: variables.colors.divider,
        tableBorderColor: variables.colors.border,
        linkHoverColor: variables.colors.text.primary,
    },
    contactUs: {
        backgroundColor: variables.colors.divider,
        activeBackgroundColor: variables.colors.elementBackground,
    },
    topCarUSP: {
        gradientColor: variables.colors.divider,
    },
    palette: {
        primary: variables.colors.primary,
        secondary: variables.colors.secondary,
        error: variables.colors.error,
        text: variables.colors.text,
        backgroundSecondary: {
            default: variables.colors.background,
            paper: variables.colors.divider,
        },
        background: {
            default: variables.colors.background,
            paper: variables.colors.divider,
        },
        divider: variables.colors.border,
        grey: {
            400: variables.colors.border,
        },
        icons: {
            main: variables.colors.icons.main,
        },
    },
    typography: {
        fontFamily: getFontFamily("Volvia"),
        color: variables.colors.text.primary,
        root: {
            fontFamily: getFontFamily("Volvia"),
        },
        h1: {
            fontSize: "2.25rem",
            lineHeight: "2.75rem",
            color: variables.colors.text.primary,
            "word-break": "break-word",
            fontWeight: 500,
            [theme.breakpoints.up("md")]: {
                fontSize: "2.5rem",
                lineHeight: "3rem",
            },
        },
        h2: {
            fontSize: "1.75rem",
            lineHeight: "2.25rem",
            color: variables.colors.text.primary,
            "word-break": "break-word",
            fontWeight: 500,
            [theme.breakpoints.up("md")]: {
                fontSize: "2rem",
                lineHeight: "2.5rem",
            },
        },
        h3: {
            fontSize: "1.25rem",
            lineHeight: "1.75rem",
            color: variables.colors.text.secondary,
            "word-break": "break-word",
            fontWeight: 500,
            [theme.breakpoints.up("md")]: {
                fontSize: "1.5rem",
                lineHeight: "2rem",
            },
        },
        h4: {
            color: variables.colors.text.secondary,
            "word-break": "break-word",
            fontWeight: 500,
            fontSize: "1.125rem",
            lineHeight: "1.625rem",
            [theme.breakpoints.up("md")]: {
                fontSize: "1.25rem",
                lineHeight: "1.75rem",
            },
        },
        h5: {
            fontSize: "1.125rem",
            color: variables.colors.primary.main,
            "word-break": "break-word",
            fontWeight: 500,
            [theme.breakpoints.up("md")]: {
                fontSize: "1.25rem",
                lineHeight: "1.75rem",
            },
        },
        h6: {
            color: variables.colors.secondary.main,
            "word-break": "break-word",
            fontSize: "1rem",
            lineHeight: "1.75rem",
        },
        // helper text
        caption: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
        },
        button: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
            fontWeight: 500,
            minHeight: 48,
        },
        subtitle2: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
            color: variables.colors.text.primary,
            fontWeight: 500,
        },
        body1: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
            color: variables.colors.text.primary,
        },
        body2: {
            fontSize: "1.2rem",
            lineHeight: "1.5rem",
            color: variables.colors.primary.main,
        },
    },
    teaser: {
        root: {
            backgroundColor: variables.colors.elementBackground,
            border: false,
        },
        container: {
            backgroundColor: variables.colors.teaserBackground,
        },
    },
    navigation: {
        backgroundColor: variables.colors.elementBackground,
        divider: variables.colors.divider,
        iconColor: variables.colors.text.secondary,
        megaBackgroundColor: variables.colors.elementBackground,
        mobileCollapseBackgroundColor: variables.colors.elementBackground,
    },
    overrides: {
        MuiTypography: {
            root: {
                fontFamily: getFontFamily("Volvia"),
            },
        },
        MuiLink: {
            underlineHover: {
                "a&": {
                    // to increase specificy
                    color: variables.colors.primary.main,
                    fontWeight: 500,
                    textDecoration: "none",
                    "&:hover": {
                        color: variables.colors.text.primary,
                    },
                    "&:active": {
                        color: variables.colors.text.hint,
                    },
                },
            },
        },
        MuiMobileStepper: {
            dot: {
                width: 16,
                height: 16,
                margin: "0 12px",
            },
        },
        MuiCardMedia: {
            root: {
                display: "flex",
            },
        },
        MuiTooltip: {
            popper: {
                pointerEvents: "auto",
            },
        },
        MuiIconButton: {
            root: {
                "&:hover": {
                    backgroundColor: variables.colors.transparent,
                },
            },
        },
        MuiDialogContent: {
            root: {
                paddingTop: 0,
                paddingBottom: 24,
            },
        },
        MuiButton: {
            root: {
                borderRadius: 3,
                "text-transform": "none",
            },
            outlined: {
                color: variables.colors.primary.main,
                borderColor: variables.colors.primary.main,
            },
            contained: {
                boxShadow: props.buttons.boxShadow,
                "&:hover": {
                    boxShadow: props.buttons.boxShadow,
                },
                "&:active": {
                    boxShadow: props.buttons.boxShadow,
                },
                "&$focusVisible": {
                    boxShadow: props.buttons.boxShadow,
                },
                "a&": {
                    "&:hover": {
                        color: variables.colors.primary.contrastText,
                        backgroundColor: variables.colors.primary.dark,
                    },
                    "&:active": {
                        color: variables.colors.primary.contrastText,
                        backgroundColor: variables.colors.primary.dark,
                    },
                    color: variables.colors.primary.contrastText,
                    backgroundColor: variables.colors.primary.main,
                    textDecoration: "none",
                },
            },
        },
        MuiInputLabel: {
            formControl: {
                transform: "none",
                color: variables.colors.primary.main,
                lineHeight: 1.75,
            },
            outlined: {
                "&$shrink": {
                    transform: "translate(10px, -20px) scale(1)",
                },
            },
        },
        MuiRadio: {
            colorSecondary: {
                "&$checked": {
                    color: variables.colors.text.secondary,
                },
            },
        },
    },
};
export default createTheme(volviano);
